import React from "react";
import { SEO, MainLayout, OrderLabel } from "../../../components";

const OrderLabelPage = () => {
  return (
    <>
      <SEO title="label" />
      <MainLayout>
        <OrderLabel />
      </MainLayout>
    </>
  );
};

export default OrderLabelPage;
